module.exports = __webpack_public_path__ + "static/car_product_4-573defa2ed8e93392dfcd7637e0b2086.jpg";